import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "text-body-2 text-grey mb-2"
}
const _hoisted_3 = { class: "members-head text-caption text-medium-emphasis" }
const _hoisted_4 = { class: "head-user" }
const _hoisted_5 = { class: "level-cell" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "level-cell" }
const _hoisted_8 = {
  key: 1,
  class: "d-inline-flex flex-wrap ga-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_person_select = _resolveComponent("ontos-person-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_ontos_colored_select = _resolveComponent("ontos-colored-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ontos_colored_value = _resolveComponent("ontos-colored-value")!
  const _component_ontos_person_line = _resolveComponent("ontos-person-line")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_ontos_section = _resolveComponent("ontos-section")!
  const _component_ontos_ask_dialog = _resolveComponent("ontos-ask-dialog")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, { ref: "base" }), {
    default: _withCtx(() => [
      (_ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_ontos_section, {
              header: false,
              divider: false
            }, {
              default: _withCtx(() => [
                (_ctx.can('admin'))
                  ? (_openBlock(), _createBlock(_component_v_form, {
                      key: 0,
                      onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.addMember()), ["prevent"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          align: "start",
                          class: "mb-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "6",
                              md: "5"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ontos_person_select, {
                                  free: "",
                                  modelValue: _ctx.email,
                                  "onUpdate:modelValue": [
                                    _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                                    _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateEmail($event)))
                                  ],
                                  people: _ctx.invitable,
                                  label: _ctx.$tt('member-search'),
                                  "error-messages": _ctx.emailError,
                                  hint: _ctx.unknownEmailHint,
                                  "persistent-hint": "",
                                  "onUpdate:search": _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSearch($event))),
                                  density: "compact",
                                  variant: "outlined",
                                  "hide-details": "auto"
                                }, null, 8, ["modelValue", "people", "label", "error-messages", "hint"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "8",
                              sm: "4",
                              md: "3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ontos_colored_select, {
                                  modelValue: _ctx.level,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.level) = $event)),
                                  items: _ctx.levels,
                                  label: _ctx.$tt('access-level')
                                }, null, 8, ["modelValue", "items", "label"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "4",
                              sm: "2",
                              class: "pt-4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  type: "submit",
                                  variant: "text",
                                  color: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { start: "" }, {
                                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                        _createTextVNode("mdi-account-plus", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$tt('member-add')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.onlyAdmin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$tt('last-admin-note')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$tt('user')), 1),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$tt('access-level')), 1),
                  (_ctx.roleItems.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$tt('roles')), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_v_list, { density: "compact" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.members, (member) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: member.user
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ontos_person_line, {
                            user: member.user,
                            email: member.email,
                            name: member.name,
                            photo: member.photo
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, [
                                (!_ctx.can('admin') || _ctx.locked(member))
                                  ? (_openBlock(), _createBlock(_component_ontos_colored_value, {
                                      key: 0,
                                      option: _ctx.levelOption(member.accessLevel),
                                      form: "chip"
                                    }, null, 8, ["option"]))
                                  : (_openBlock(), _createBlock(_component_ontos_colored_select, {
                                      key: 1,
                                      "model-value": member.accessLevel,
                                      items: _ctx.levels,
                                      variant: "plain",
                                      "onUpdate:modelValue": ($event: any) => (_ctx.changeLevel(member, $event))
                                    }, null, 8, ["model-value", "items", "onUpdate:modelValue"]))
                              ]),
                              (_ctx.roleItems.length)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_ctx.can('admin'))
                                      ? (_openBlock(), _createBlock(_component_ontos_colored_select, {
                                          key: 0,
                                          multiple: "",
                                          "model-value": member.roles || [],
                                          items: _ctx.roleItems,
                                          placeholder: _ctx.$tt('roles'),
                                          variant: "plain",
                                          class: "roles-select",
                                          "onUpdate:modelValue": ($event: any) => (_ctx.changeRoles(member, $event))
                                        }, null, 8, ["model-value", "items", "placeholder", "onUpdate:modelValue"]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rolesOf(member), (role) => {
                                            return (_openBlock(), _createBlock(_component_ontos_colored_value, {
                                              key: role.value,
                                              option: role,
                                              form: "chip"
                                            }, null, 8, ["option"]))
                                          }), 128))
                                        ]))
                                  ], 64))
                                : _createCommentVNode("", true),
                              (_ctx.can('admin') && !_ctx.locked(member))
                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 1,
                                    variant: "text",
                                    icon: "",
                                    size: "small",
                                    color: "error",
                                    title: _ctx.$tt('remove'),
                                    onClick: ($event: any) => (_ctx.removing = member)
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                          _createTextVNode("mdi-account-remove", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["title", "onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["user", "email", "name", "photo"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.removing)
              ? (_openBlock(), _createBlock(_component_ontos_ask_dialog, {
                  key: 0,
                  title: _ctx.$tt('member-remove-confirm', {email: _ctx.removing.email}),
                  message: _ctx.$tt('member-remove-explain'),
                  actions: _ctx.removeActions,
                  onPick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onRemovePicked($event))),
                  onClosed: _cache[6] || (_cache[6] = ($event: any) => (_ctx.removing = null))
                }, null, 8, ["title", "message", "actions"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}